import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import { Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
// import bgimage from '../../../../images/default_staff.png';
import bgimage from '../../../../images/vendor/vendor.png';
import swal from "sweetalert2"; 
import FileUpload from "react-material-file-upload";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const AddVendor = () => {
const baseURL = process.env.REACT_APP_API_BASE_URL;
const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
const user_id = parseInt(localStorage.getItem("user_id"), 10);
const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [settlementTypeOption, setSettlementTypeOption] = useState([ 
    { value: 0, label: 'Weeks' },
    { value: 1, label: 'Months' },
    { value: 2, label: 'Years' },
  ]);
  const [selectedSettlementType, setSelectedSettlementType] = useState(null);
  const [selectedSelectType, setSelectedSelectType] = useState(null); // corresponds to your 'select_type'
  
  // State for form inputs
  const [formData, setFormData] = useState({
    vendorBusinessName: '',
    vendorMobileNo: '',
    vendorEmailId: '',
    settlementTypeInput: '',
    businessRegNo: '',
    gstNo: '',
    taxNo: '',
    // openingBalanceAmount: '',
    address: '',
    personName: '',
    personRole: '',
    personMobileNo: '',
    personAlternativeNo: '',
    alternativeNo: '',
    bankInformationChecked: false,
    bankName: '',
    branchName: '',
    accountHolderName: '',
    accountNo: '',
    ifscCode: '',
    description: '',
    openingBalanceType: '0', // '0' for Credit, '1' for Debit
  });

  // File states
  const [file, setFile] = useState(null); // vendor image
  const [files, setFiles] = useState([]); // attachments

  const imageInputRef = useRef();

 
    useEffect(() => {
        axios.get(`${baseURL}/vendorcategory/category/active`)
        .then(response => {
            const options = response.data.map(category => ({
            value: category.sno,
            label: category.vendorcategory_name,
            }));
            setCategories(options);
        })
        .catch(error => {
            console.error('Error fetching categories:', error); 
        });
    }, [baseURL]);

    // Fetch Business Types
    useEffect(() => {
        axios.get(`${baseURL}/businesstype/type/active`)
        .then(response => {
            const options = response.data.map(type => ({
            value: type.sno,
            label: type.businesstype_name,
            }));
            setBusinessTypes(options);
        })
        .catch(error => {
            console.error('Error fetching business types:', error);
        });
    }, [baseURL]);

  // Handlers for form inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    setFormData(prev => ({ ...prev, bankInformationChecked: e.target.checked }));
  };

  // const fileHandler = (e) => {
  //   setFile(e.target.files[0]);
  // };

  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) imageInputRef.current.value = null;
  };

  const handleFileChange = (newFiles) => {
    setFiles(newFiles);
  };

 
    const [errors, setErrors] = useState({});
    const validateForm = () => {
  const newErrors = {};

  if (!selectedCategory) newErrors.selectedCategory = "Category is required.";
  if (!formData.vendorBusinessName) newErrors.vendorBusinessName = "Vendor Business Name is required.";
  if (!formData.vendorMobileNo) newErrors.vendorMobileNo = "Vendor Mobile No is required.";
  if (!formData.vendorEmailId) newErrors.vendorEmailId = "Email Id is required.";
  if (!selectedBusinessType) newErrors.selectedBusinessType = "Business Type is required.";
  if (!formData.settlementTypeInput) newErrors.settlementTypeInput = "Settlement Type is required.";
  if (!selectedSelectType) newErrors.selectedSelectType = "Settlement Type unit is required.";
  // if (!formData.openingBalanceAmount) newErrors.openingBalanceAmount = "Opening Balance Amount is required.";
  if (!formData.address) newErrors.address = "Address is required.";
  if (!formData.personName) newErrors.personName = "Primary Contact Name is required.";
  if (!formData.personRole) newErrors.personRole = "Role/Position is required.";
  if (!formData.personMobileNo) newErrors.personMobileNo = "Primary Mobile No is required.";

  if (formData.bankInformationChecked) {
    if (!formData.bankName) newErrors.bankName = "Bank Name is required.";
    if (!formData.branchName) newErrors.branchName = "Branch Name is required.";
    if (!formData.accountHolderName) newErrors.accountHolderName = "Account Holder Name is required.";
    if (!formData.accountNo) newErrors.accountNo = "Account No is required.";
    if (!formData.ifscCode) newErrors.ifscCode = "IFSC Code is required.";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

    const handleSubmit = async (e) => {
  if (e && e.preventDefault) e.preventDefault(); // ✅ Only prevent default if event exists

  const data = new FormData();

  // Map your form fields to API expected fields:
  data.append('vendor_category', selectedCategory?.value || '');
  data.append('vendor_businessname', formData.vendorBusinessName);
  data.append('vendor_mobileno', formData.vendorMobileNo);
  data.append('vendor_emailid', formData.vendorEmailId);
  data.append('business_type', selectedBusinessType?.value || '');
  data.append('settlement_type', formData.settlementTypeInput);
  data.append('select_type', selectedSelectType?.value ?? '');
  // data.append('opening_balance', formData.openingBalanceType);
  // data.append('opening_balance_amount', formData.openingBalanceAmount);
  data.append('address', formData.address);

  data.append('person_name', formData.personName);
  data.append('person_role', formData.personRole);
  data.append('person_mobileno', formData.personMobileNo);
  data.append('person_alternative_no', formData.personAlternativeNo);
  data.append('alternative_no', formData.alternativeNo);

  data.append('bank_information', formData.bankInformationChecked ? 0 : 1);

  if (formData.bankInformationChecked === true) {
    data.append('bank_name', formData.bankName);
    data.append('branch_name', formData.branchName);
    data.append('account_holder_name', formData.accountHolderName);
    data.append('account_no', formData.accountNo);
    data.append('ifsc_code', formData.ifscCode);
  }

  data.append('description', formData.description);
  data.append('business_regno', formData.businessRegNo);
  data.append('gstno', formData.gstNo);
  data.append('taxno', formData.taxNo);
  data.append('created_by', user_id);
  data.append('branch_id', branch_id);

  if (file) {
    data.append('vendor_image', file);
  }

  files.forEach((fileItem, index) => {
    data.append(`attachments[${index}]`, fileItem);
  });

  try {
    const response = await axios.post(`${baseURL}/managevendor`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }, 
    });
    navigate('/manage-vendors', {
        state: { toastMessage: 'Vendor Created Successfully!', toastType: 'success' }
    });
  } catch (error) {
    console.error(error);
    navigate('/manage-vendors', {
        state: { toastMessage: 'Error Creating Vendor', toastType: 'error' }
    });
  }
};

 
const ConfirmationModal = async () => {
  if (!validateForm()) return; // 🔒 Don't show modal if validation fails

  const result = await swal.fire({
    html: `
      <div class="alert alert-success px-2 py-2" role="alert">
        Are you sure you want to create this vendor?
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <p class="text-center"><b>${formData.vendorBusinessName || 'Vendor'}</b></p>
    `,
    showCancelButton: true,
    confirmButtonText: 'Yes!',
    cancelButtonText: 'No',
    reverseButtons: true,
    customClass: {
      title: 'fs-6',
      cancelButton: 'btn btn-sm btn-secondary',
      confirmButton: 'btn btn-sm btn-success',
      htmlContainer: 'text-left'
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
  });

  if (result.isConfirmed) {
    await handleSubmit();
  }
};

const fileHandler = (event) => {
  const selectedFile = event.target.files[0];

  if (!selectedFile) return;

  const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const maxSizeKB = 50; // max size in KB

  if (!allowedTypes.includes(selectedFile.type)) {
    swal.fire('Error', 'Only JPG, JPEG, and PNG files are allowed.', 'error');
    event.target.value = null; // reset file input
    return;
  }

  if (selectedFile.size / 1024 > maxSizeKB) {
    swal.fire('Error', 'File size must be less than 50 KB.', 'error');
    event.target.value = null; // reset file input
    return;
  }

  // If passes all checks, update the file state
  setFile(selectedFile);
};


  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
          <div className='mb-2'>
            <div className="mb-0 px-0">
              <h4 style={{ color: '#025d3a' }}>Add Vendor</h4>
            </div>
            <ol className="breadcrumb fs-7">
              <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
              <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
              <li className="breadcrumb-item">Purchase Management</li>
              <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
              <li className="breadcrumb-item active"><Link to='/manage-items'>Manage Vendors</Link></li>
            </ol>
          </div>
        </div>

        {/* Basic Information */}
        <label className='text-red fs-4 font-w600 mb-3'>Basic Information</label>
        <div className="row">
          <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7"> Category  <span className="required">*</span></label>
                  <Select
          placeholder='Select Category'
          options={categories}
          value={selectedCategory}
          onChange={setSelectedCategory}
        />
         {errors.selectedCategory && <span className="text-danger">{errors.selectedCategory}</span>}
                </div>

          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Vendor Business Name <span className="required">*</span></label>
             <input
              name="vendorBusinessName"
              value={formData.vendorBusinessName}
              onChange={handleInputChange}
              type="text"
              className="form-control"
              placeholder="Enter Vendor Business Name"
               
            />  
            {errors.vendorBusinessName && <span className="text-danger">{errors.vendorBusinessName}</span>}
          </div>
 

          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">
              Vendor Mobile No <span className="required">*</span>
            </label>
            <input
              name="vendorMobileNo"
              value={formData.vendorMobileNo}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only digits
                if (/^\d*$/.test(value)) {
                  // Enforce max length of 10
                  if (value.length <= 10) {
                    // Allow first digit to be 6, 7, 8, or 9
                    if (value === "" || /^[6-9]/.test(value)) {
                      handleInputChange(e);
                    }
                  }
                }
              }}
              type="text"
              className="form-control"
              placeholder="Enter Vendor Mobile No"
              maxLength="10"
            />
            {errors.vendorMobileNo && (
              <span className="text-danger">{errors.vendorMobileNo}</span>
            )}
          </div>



          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Email Id<span className="required">*</span></label>
            <input
              name="vendorEmailId"
              value={formData.vendorEmailId}
              onChange={handleInputChange}
              type="email"
              className="form-control"
              placeholder="Enter Email Id"
               
            />
            {errors.vendorEmailId && <span className="text-danger">{errors.vendorEmailId}</span>}
          </div>

          <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7"> Business Type<span className="required">*</span></label>
                    <Select
                        placeholder='Select Business Type'
                        options={businessTypes}
                        value={selectedBusinessType}
                        onChange={setSelectedBusinessType}
                        />
                        {errors.selectedBusinessType && <span className="text-danger">{errors.selectedBusinessType}</span>}
              </div>
                
          <div className="col-lg-4 mb-4 ">
            <label className="text-black font-w500 fs-7"> Settlement Type<span className="required">*</span></label>
            <div className='row'>
              <div className='col-lg-6'>
                <input
                  name="settlementTypeInput"
                  value={formData.settlementTypeInput}
                  onChange={handleInputChange}
                  type="text"
                  className="form-control"
                  placeholder="Enter Settlement Type"
                   
                />
              </div>
              <div className='col-lg-6'>
                <Select
                  placeholder='Select Type'
                  options={settlementTypeOption}
                  value={selectedSelectType}
                  onChange={setSelectedSelectType}
                />
              </div>
                {errors.settlementTypeInput && <span className="text-danger">{errors.settlementTypeInput}</span>}

            </div>
          </div> 

         

          <div className="col-lg-4 mb-4">
          <label className="text-black font-w500 fs-7">CIN</label>
          <input
            name="businessRegNo"
            value={formData.businessRegNo}
            onChange={(e) => {
              const value = e.target.value.toUpperCase();

              if (/^[A-Z0-9]{0,21}$/.test(value)) {
                handleInputChange({
                  ...e,
                  target: {
                    ...e.target,
                    value,
                    name: e.target.name  // <--- Add this line to preserve the name
                  }
                });
              }
            }}
            
            type="text"
            className="form-control"
            placeholder="Enter CIN"
            maxLength={21}
          />
        </div>


            <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7">GST No</label>
                <input
                  name="gstNo"
                  value={formData.gstNo}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

                    // Allow typing up to 15 alphanumeric characters only
                    if (/^[A-Z0-9]{0,15}$/.test(value)) {
                      handleInputChange({ ...e, target: { ...e.target, value, name: e.target.name  } });

                      // Optional format check when length is 15
                      if (value.length === 15 && !gstPattern.test(value)) {
                        console.warn("Invalid GST format");
                      }
                    }
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Enter GST No"
                  maxLength="15"
                />
            </div> 


          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Address<span className="required">*</span></label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleInputChange} 
              className="form-control"
              placeholder="Address"
              
            />
            {errors.address && <span className="text-danger">{errors.address}</span>}
          </div>

          <div className="col-lg-4 mb-4"> 
            <label className="text-black font-w500 fs-7 d-block">Vendor Image</label>
            <span className='fs-8 text-gray-800'>Size: </span>
            <span className='fs-8 text-danger'>15 * 15</span> 
            <span className='fs-8 text-gray-800 ms-2'>Format: </span>
            <span className='fs-8 text-danger'>.png, .jpg</span>
            <div className="avatar-upload d-flex align-items-center"> 
              <div className="change position-relative">
                <div className="avatar-preview h-100px w-100px border" style={{ borderRadius: '10px' }}>
                   <img
                                    id="saveImageFile"
                                    src={file ? URL.createObjectURL(file) : bgimage}
                                    alt={file ? file.name : 'Default Avatar'}
                                    className="p-1 h-100px w-100px"
                                />
                </div>
                <div className="change-btn">
                  <input 
                    type="file"
                    id="imageUpload"
                    accept=".png, .jpg, .jpeg"
                    style={{ display: 'none' }}
                    onChange={fileHandler}
                    ref={imageInputRef}
                  />
                  <div className="mt-2 d-flex justify-content-center gap-3">
                    <Button
                      className="btn-xs mb-2"
                      variant="success"
                      onClick={() => imageInputRef.current.click()}
                    >
                      <i className="fa fa-upload color-success fs-5" />
                    </Button>
                    <Button
                      className="btn-xs mb-2"
                      variant="danger"
                      onClick={RemoveImage}
                    >
                      <i className="fa fa-close color-danger fs-5" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <label className="text-red fs-4 font-w600 mb-3">Contact Information</label>
        <div className='row'>
          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Primary Contact Person Name <span className="required">*</span></label>
            <input
              name="personName"
              value={formData.personName}
              onChange={handleInputChange}
              type="text"
              className="form-control"
              placeholder="Enter Primary Contact Person Name"
            />
            {errors.personName && <span className="text-danger">{errors.personName}</span>}
          </div>

          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Role/Positon <span className="required">*</span></label>
            <input
              name="personRole"
              value={formData.personRole}
              onChange={handleInputChange}
              type="text"
              className="form-control"
              placeholder="Enter Role/Positon"
            />
            {errors.personRole && <span className="text-danger">{errors.personRole}</span>}
          </div>
         
         
           <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">
             Primary Mobile No <span className="required">*</span>
            </label>
            <input
               name="personMobileNo"
               value={formData.personMobileNo}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only digits
                if (/^\d*$/.test(value)) {
                  // Enforce max length of 10
                  if (value.length <= 10) {
                    // Allow first digit to be 6, 7, 8, or 9
                    if (value === "" || /^[6-9]/.test(value)) {
                      handleInputChange(e);
                    }
                  }
                }
              }}
              type="text"
              className="form-control"
               placeholder="Enter Primary Mobile No"
              maxLength="10"
            />
           {errors.personMobileNo && <span className="text-danger">{errors.personMobileNo}</span>}
          </div>
 

          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Alternate Contact Person Name</label>
            <input
              name="personAlternativeNo"
              value={formData.personAlternativeNo}
              onChange={handleInputChange}
              type="text"
              className="form-control"
              placeholder="Enter Alternate Contact Person Name"
            />
          </div>

 

           <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">
             Alternate Mobile No<span className="required">*</span>
            </label>
            <input
               name="alternativeNo"
              value={formData.alternativeNo}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only digits
                if (/^\d*$/.test(value)) {
                  // Enforce max length of 10
                  if (value.length <= 10) {
                    // Allow first digit to be 6, 7, 8, or 9
                    if (value === "" || /^[6-9]/.test(value)) {
                      handleInputChange(e);
                    }
                  }
                }
              }}
              type="text"
              className="form-control"
               placeholder="Enter Alternate Mobile No"
              maxLength="10"
            /> 
          </div>


        </div>

        {/* Bank Information */}
        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="bankInfoCheck"
            checked={formData.bankInformationChecked}
            onChange={handleCheckboxChange}
          />
         <label className="text-red fs-4 font-w600 mb-3" htmlFor="customCheckBox1">Bank Information</label>
        </div>

        {formData.bankInformationChecked && (
          <div className='row'>
            <div className="col-lg-4 mb-4">
              <label className="text-black font-w500 fs-7">Bank Name<span className="required">*</span></label>
              <input
                name="bankName"
                value={formData.bankName}
                onChange={handleInputChange}
                type="text"
                className="form-control"
                placeholder="Enter Bank Name"
              />
                 {errors.bankName && <span className="text-danger">{errors.bankName}</span>}
            </div>

            <div className="col-lg-4 mb-4">
              <label className="text-black font-w500 fs-7">Branch Name<span className="required">*</span></label>
              <input
                name="branchName"
                value={formData.branchName}
                onChange={handleInputChange}
                type="text"
                className="form-control"
                placeholder="Enter Branch Name"
              />
                 {errors.branchName && <span className="text-danger">{errors.branchName}</span>}
            </div>

            <div className="col-lg-4 mb-4">
              <label className="text-black font-w500 fs-7">Account Holder Name<span className="required">*</span></label>
              <input
                name="accountHolderName"
                value={formData.accountHolderName}
                onChange={handleInputChange}
                type="text"
                className="form-control"
                placeholder="Enter Account Holder Name"
              />
                 {errors.accountHolderName && <span className="text-danger">{errors.accountHolderName}</span>}
            </div>

       

            <div className="col-lg-4 mb-4">
              <label className="text-black font-w500 fs-7">
                Account No <span className="required">*</span>
              </label>
              <input
                name="accountNo"
                value={formData.accountNo}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only digits and limit to 18 characters
                  if (/^\d{0,18}$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                type="text"
                className="form-control"
                placeholder="Enter Account No"
                maxLength="18"
              />
              {errors.accountNo && (
                <span className="text-danger">{errors.accountNo}</span>
              )}
            </div>


       

            <div className="col-lg-4 mb-4">
              <label className="text-black font-w500 fs-7">
                IFSC Code <span className="required">*</span>
              </label>
              <input
                name="ifscCode"
                value={formData.ifscCode}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase(); // Convert to uppercase
                  // Allow only alphanumeric input and limit to 11 characters
                  if (/^[A-Z0-9]{0,11}$/.test(value)) {
                    handleInputChange({ ...e, target: { ...e.target, value } });
                  }
                }}
                type="text"
                className="form-control"
                placeholder="Enter IFSC Code"
                maxLength="11"
              />
              {errors.ifscCode && (
                <span className="text-danger">{errors.ifscCode}</span>
              )}
            </div>


          </div>
        )}

    

         

          <div className='row'>
            <div className='col-lg-6 mb-4'>
                <label className="text-black font-w500 fs-7">Attachment</label>
                <div className='mt-2'>
                    <FileUpload
                        maxFiles={4}
                        value={files}
                        onChange={handleFileChange}
                         multiple
                          accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
                    />
                </div>
            </div>
            <div className='col-lg-6 mt-1'>
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                   className="form-control h-auto"
                    placeholder="Enter Description"
                    rows={6}
                />
            </div>
        </div>
         <div className="d-flex align-items-center justify-content-end gap-3 mt-4 ">
            <Link to={'/manage-vendors'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
            <Button type="button" className="btn btn-sm btn-primary" onClick={ConfirmationModal} >Create Vendor</Button>
        </div>
      </form>
    </>
  );
};

export default AddVendor;
